// This encapsulates pushing any GTM Tags
export const handleGtmTags = (result:{gtm:any[]}) => {
	if ( result.gtm && window['gtmPush'] ) {
		result.gtm.forEach( (tag:any) => {
			window['gtmPush'](tag);
		});
	}
}

export default handleGtmTags;
